<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item label='角色'>
                            <el-select v-model="roleId" @change="initData" placeholder='请选择角色'>
                                <el-option :key="roleItem.id" v-for="roleItem in allRole" :label="roleItem.roleName"
                                           :value="roleItem.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getData()">查询</el-button>
                            <el-button type="danger" @click="createPopupShow = true">创建角色</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div v-if="!saveDisabled">
                    <el-table border :data="permissionTree.values" :show-header="false" style="width: 100%">
                        <el-table-column width="150">
                            <template slot-scope="scope">
                                <el-checkbox :label="scope.$index"
                                             v-model="checkAllArr[scope.$index]" @change="selectAll(scope.$index)">
                                    {{permissionConfig.name[permissionTree.keys[scope.$index]] }}
                                </el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column width="">
                            <template slot-scope="scope">
                                <el-checkbox-group v-model="roleIds[scope.$index]" @change="selectRole(scope.$index)">
                                    <el-checkbox v-for="(role,idx) in scope.row" :label="role" :key="idx">
                                        {{permissionConfig.name[role]}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="data-control">
                        <el-button @click="resetData">重置</el-button>
                        <el-button type="primary" @click="save" :disabled="saveDisabled">保存</el-button>
                    </div>
                </div>

                <!-- 新增 -->
                <el-dialog title='新增角色' :visible.sync="createPopupShow" width="30%" lock-scroll center
                           @close="cancelCreate">
                    <div>
                        <el-form ref="form" :model="roleForm" label-width="100px">
                            <el-form-item label='名称'>
                                <el-input v-model="roleForm.roleName"></el-input>
                            </el-form-item>
                            <el-form-item label='备注'>
                                <el-input v-model="roleForm.remark"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancelCreate">取消</el-button>
                        <el-button type="primary" @click="submitCreate">确定</el-button>
                    </div>
                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
    import Vue from 'vue'
    import roleApi from '../../service/role_api'
    import accountService from '../../service/account_api'

    import {
        mapState
    } from 'vuex';

    export default {
        data() {
            return {
                title: this.$route.meta.title,
                roleId: '',

                permissionConfig: {},
                permissionTree: {},
                allRole: [],
                checkAllArr: [],
                roleIds: [],
                roleForm: {
                    roleName: '',
                    remark: ''
                },
                createPopupShow: false,

                saveDisabled: true,
            }
        },
        created() {
            this.getAllRole();
        },
        mounted() {
            //this.initData();
            this.getMenu();
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                permissions: state => state.user.permissions
            }),
        },
        methods: {
            getMenu() {
                var permissionConfig = {};
                var permissionTreeKeys = [];
                var permissionTreeValues = [];
                accountService.allMenu().then(res => {
                    res.forEach(item => {
                        permissionConfig[item.id] = item.name;
                        permissionTreeKeys.push(item.id)
                        item.subMenus.forEach(iitem => {
                            permissionConfig[iitem.id] = iitem.name;
                        })
                    })
                    permissionTreeKeys.sort(function(a,b){return a-b});
                })
                this.permissionConfig.name = permissionConfig;
                this.permissionTree.keys = permissionTreeKeys;

                for (var i in this.permissions) {
                    if (i !== '-1') {
                        permissionTreeValues.push(this.permissions[i])
                    }
                }
                this.permissionTree.values = permissionTreeValues;
            },

            // 初始化数据
            initData() {
                const tree = this.permissionTree.values;
                this.checkAllArr = [];
                this.roleIds = [];
                tree.forEach(item => {
                    this.checkAllArr.push([]);
                    this.roleIds.push([]);
                });

                this.saveDisabled = true;
            },
            getAllRole() {
                let self = this;
                roleApi.allRole({
                    token: self.token
                }).then(res => {
                    self.allRole = res;
                })
            },
            // 获取管理员数据
            getData(params = {}) {
                let {
                    roleId = this.roleId, token = this.token
                } = params;

                if (roleId) {
                    roleApi.findById({
                        roleId,
                        token
                    }).then(res => {
                        this.initData();
                        for (var key in res) {
                            var index = this.permissionTree.keys.indexOf(key >> 0);
                            if (index > -1) {
                                this.roleIds[index] = res[key];
                            }
                        }
                        var permissionTree = this.permissionTree;
                        for (var i = 0; i < permissionTree.values.length; i++) {
                            var subList = permissionTree.values[i];
                            if (subList.length == this.roleIds[i].length) {
                                this.checkAllArr[i] = true;
                            }
                        }
                        this.saveDisabled = false;
                    })
                }
            },

            // 角色权限全选事件
            selectAll(index) {
                var sublist = this.permissionTree.values[index];
                var options = [];
                for (var i = 0; i < sublist.length; i++) {
                    options.push(sublist[i]);
                }
                var item = event.target.checked ? options : [];
                this.roleIds.splice(index, 1, item);
            },
            // 角色权限选择事件
            selectRole(index) {
                var checkedCount = this.roleIds[index].length;
                var sublist = this.permissionTree.values[index];
                /*this.checkAllArr[index] = checkedCount === sublist.length;*/
                Vue.set(this.checkAllArr, index, checkedCount === sublist.length)
            },

            // 重置数据
            resetData() {
                this.initData();
                this.roleId = '';
            },
            addRole() {
                let self = this;
                roleApi.addRole({
                    token: self.token,
                    roleForm: {
                        roleName: self.roleForm.roleName,
                        remark: self.roleForm.remark,
                    }
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '添加成功'
                    });
                    self.getAllRole();
                })
            },
            // 取消添加
            cancelCreate() {
                this.roleForm = {
                    roleName: '',
                    remark: ''
                }
                this.createPopupShow = false;
            },
            // 新增角色
            submitCreate() {
                this.addRole();
                this.createPopupShow = false;
            },

            // 保存权限修改
            save() {
                let roleId = this.roleId,
                    roleIds = this.roleIds,
                    token = this.token;

                if (!roleId) return;

                let pageArrs = [];
                roleIds.forEach(arr => {
                    if (arr.length > 0) {
                        arr.forEach(item => {
                            pageArrs.push(item)
                        })
                    }
                })

                roleApi.updateRole({
                    roleId,
                    pageArrs,
                    token
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '更新成功'
                    });
                    this.getData();
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/dev_tools/roles.vue